<template>
<div class="p-6">
	<h2 class="text-xl font-semibold text-gray-700 mb-4">Rastreamento em Tempo Real</h2>
	<GMapMap
	:center="center"
	:zoom="5"
	class="w-full h-[500px] rounded-lg shadow"
	>
	<GMapMarker
  v-for="(pessoa, index) in localizacoes"
  :key="index"
  :position="{ lat: parseFloat(pessoa.lat), lng: parseFloat(pessoa.lng) }"
  :title="pessoa.nome"
>
  <GMapInfoWindow :opened="true">
    <div class="text-sm">
      <p class="font-bold">Cliente: {{ pessoa.nome }}</p>
      <p class="text-gray-600">Consultor: {{ pessoa.consultor }}</p>
      <p class="text-gray-600">Status: {{ pessoa.status }}</p>
    </div>
  </GMapInfoWindow>
</GMapMarker>
	</GMapMap>
</div>
<CommonLoading
		v-if="loading"
	/>
</template>
  
<script>

import VisitasRepository from '@/services/VisitasRepository.vue';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import CommonLoading from '@/components/generalcomponents/CommonLoading';

export default {
name: 'GerenciamentoRotasMaps',
	async mounted() {
		await this.pageData();
		this.intervalId = setInterval(() => {
			// Verifica se a rota ainda é "/gerenciamento-rotas"
			if (window.location.pathname.endsWith('/gerenciamento-rotas')) {
				this.pageData();
			} else {
				clearInterval(this.intervalId); // Cancela o setInterval se sair da rota
			}
		}, 10000); // Atualiza a cada 10 segundos
	},
	beforeUnmount() {
		if (this.intervalId) {
		clearInterval(this.intervalId);
		}
	},
	data() {
		return {
			center: {
				lat: -23.55052,
				lng: -46.633308
			},
			localizacoes: [],
			loading : false, 
			visitasPage:process.env.VUE_APP_API_URL+"visitas/ativas",
			onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
		}
	},
	methods:
	{
		async pageData(){
			this.loading = true; 
			const visitaRepo = new VisitasRepository();
			try {
				const response = await visitaRepo.getVisitasAtivas(this.visitasPage,this.onlineUser.token);
				if (response?.status  === 200) {
					this.localizacoes = response.data;
					this.loading = false; 
				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}
		},
	},
	components:{
		CommonLoading
	},
}
</script>

<style scoped>
/* Se quiser estilizar mais pins, popups, etc. */
</style>
